import type { OptionsDocument, QuoteTerms } from 'paintscout'
import { getInvoiceTerms } from '../get-invoice-terms'
import get from 'lodash/get'
import type { QuoteTypeOption } from '../../../options'

export function getInitialTerms(args: {
  options: OptionsDocument
  quoteType: QuoteTypeOption
  invoice?: boolean
}): QuoteTerms {
  const { options, quoteType, invoice } = args

  const termsOptions = options.options.terms

  const defaultTerms = get(termsOptions, 'defaults.all', null)
  const termsKey = quoteType?.defaultTerms ?? defaultTerms
  const quoteTerms = termsOptions?.values[termsKey] ?? termsOptions?.values[defaultTerms]
  if (invoice) {
    return getInvoiceTerms({ options, quoteTerms })
  }

  return quoteTerms
}
